// Namespaced translation helpers; shared kit components own their strings under group_leader.shared.

// REACT-053: window.I18n is absent in some render paths (and in jest), so every lookup is guarded.
export const makeT = (namespace) => (key, opts) =>
  (!window.I18n ? '' : window.I18n.t(`views.${namespace}.${key}`, opts))

// Absolute keys for app-wide strings (buttons.cancel); prefer these over a GL copy of a generic label.
export const translate = (key, opts) =>
  (!window.I18n ? '' : window.I18n.t(key, opts))

// Strings owned by the group-leader apps that have no app-wide equivalent.
export const sharedT = makeT('group_leader.shared')

// Rails locale symbols are not BCP-47 tags: Intl throws on 'fr_fr', and 'jp' is not a language
// code. undefined is what Intl expects for "browser default".
const INTL_OVERRIDES = { jp: 'ja' }

export const intlLocale = () => {
  const raw = window.I18n && window.I18n.locale
  if (!raw) { return undefined }

  return INTL_OVERRIDES[raw] || String(raw).replace('_', '-')
}
